module.exports = __webpack_public_path__ + "static/media/logo.cd5a7170.png";